// ─── FEATURES ────────────────────────────────────────────────────────
// Source: ooon.in/feature (verified)
export const FEATURES = [
  { icon: "💳", title: "Point of Sale",               desc: "Cloud POS with full cash flow control, till management, permission access, and activity tracking for every transaction." },
  { icon: "🎫", title: "KOT Integration",             desc: "Send orders instantly to the kitchen. Reduces errors and speeds up food preparation with a seamless Kitchen Order Ticket system." },
  { icon: "📺", title: "Kitchen Display System",      desc: "Go paperless — orders appear on the kitchen display in real-time. Any update on the POS instantly reflects in the kitchen." },
  { icon: "📦", title: "Inventory Management",        desc: "Track inventory in real-time, set low-stock alerts, monitor levels remotely, and get detailed ingredient usage reports." },
  { icon: "🧾", title: "All GST Types Supported",     desc: "Automatically handles CGST, SGST, IGST, and UTGST. Precise tax calculations for both intra-state and inter-state transactions." },
  { icon: "🖨️", title: "Multiple Print Options",      desc: "Generate customer bills, KOTs, and vendor invoices. Every format is customisable to suit your branding and operational needs." },
  { icon: "🏷️", title: "Shop Logo on Bill",           desc: "Print your restaurant's logo on every bill for a polished, branded customer experience." },
  { icon: "📱", title: "UPI QR Code on Bill",         desc: "Print a UPI QR code on every bill to speed up cashless payments for dine-in, takeaway, and delivery." },
  { icon: "✏️", title: "Bill Editing Option",         desc: "Add or remove items, update customer details, and make last-minute changes before finalising any bill." },
  { icon: "📊", title: "Comprehensive Reports",       desc: "Access P&L statements, ledgers, audit logs, and full transaction histories for confident, data-driven decisions." },
  { icon: "📅", title: "Day Sheet Overview",          desc: "A clear daily summary of total sales, expenses, collections, and balances for quick end-of-day reconciliation." },
  { icon: "📈", title: "Interactive Graphs",          desc: "Visualise sales trends, category performance, and monthly growth with easy-to-read interactive charts." },
  { icon: "👤", title: "Multi-User Role Management",  desc: "Assign roles and permissions to each staff member — cashier, manager, or kitchen staff — with secure logins." },
  { icon: "🛒", title: "Order & Sales Tracking",      desc: "Track all orders — dine-in, takeaway, or online — in one dashboard. Analyse sales by time, item, or payment method." },
  { icon: "🏭", title: "Vendor Sales Management",     desc: "Manage vendor purchases, payments, and generate vendor-specific reports for full procurement transparency." },
  { icon: "🗃️", title: "Raw Material Purchase Tracking", desc: "Log every ingredient purchase with cost, quantity, and vendor details for better kitchen stock control." },
  { icon: "♻️", title: "Wastage Management",         desc: "Track discarded items and integrate wastage data into your inventory reports to reduce food cost." },
  { icon: "📤", title: "Excel Export Option",         desc: "Export any report or dataset to Excel for auditing, internal review, or sharing with your accountant." },
  { icon: "🎁", title: "Redeem Points & Loyalty",     desc: "Build repeat business with a customer loyalty programme — issue and track redeemable points for every purchase." },
  { icon: "⚙️", title: "Opening Balance Setup",      desc: "Set opening balances for cash, stock, or accounts at the start of each financial cycle for accurate records." },
];

// ─── HOME FEATURES PREVIEW (6 key features shown on homepage) ────────
export const HOME_FEATURES = [
  { icon: "💳", title: "Point of Sale",              desc: "Cloud POS with full cash flow control, till management, and activity tracking for every transaction." },
  { icon: "🎫", title: "KOT Integration",            desc: "Orders go from table to kitchen instantly. No paper slips, no miscommunication, no delays." },
  { icon: "📺", title: "Kitchen Display System",     desc: "Go fully paperless. Any order change on the POS reflects on the kitchen display in real-time." },
  { icon: "🧾", title: "All GST Types",              desc: "CGST, SGST, IGST, UTGST — all handled automatically. Precise billing for every transaction type." },
  { icon: "📊", title: "Comprehensive Reports",      desc: "P&L statements, audit logs, day sheets, and interactive sales graphs — all in one dashboard." },
  { icon: "📦", title: "Inventory Management",       desc: "Real-time stock tracking with low-level alerts, ingredient usage reports, and wastage monitoring." },
];

// ─── PRICING PLANS ────────────────────────────────────────────────────
// saving: what you save vs paying monthly for that duration
// perDay: cost per day
// highlight: the standout benefit of this plan
// forWho: ideal user description
export const PLANS = [
  {
    name: "Free Trial",
    price: "0",
    period: "15 Days",
    perDay: null,
    saving: null,
    savingLabel: null,
    highlight: "Try everything free",
    forWho: "Perfect for new restaurants evaluating Ooon",
    pop: false,
    tag: null,
    feats: [
      "All 20+ features unlocked",
      "Billing & KOT",
      "GST invoice generation",
      "Inventory management",
      "Sales reports & graphs",
      "Multi-payment support",
    ],
    cta: "Start Free",
  },
  {
    name: "Silver",
    price: "399",
    period: "30 Days",
    perDay: "₹13",
    saving: null,
    savingLabel: null,
    highlight: "₹13/day — less than a chai",
    forWho: "Best for single-outlet restaurants & cafés",
    pop: true,
    tag: "Most Popular",
    feats: [
      "Everything in Free Trial",
      "Unlimited transactions",
      "Multi-user access & roles",
      "UPI QR code on bills",
      "Shop logo on bills",
      "Priority support",
    ],
    cta: "Get Silver",
  },
  {
    name: "Gold",
    price: "2,199",
    period: "6 Months",
    perDay: "₹12",
    saving: "₹195",
    savingLabel: "Save ₹195 vs monthly",
    highlight: "₹12/day — 8% cheaper than Silver",
    forWho: "Ideal for growing restaurants & small chains",
    pop: false,
    tag: "Best Value",
    feats: [
      "Everything in Silver",
      "Vendor purchase management",
      "Raw material tracking",
      "Wastage monitoring",
      "Excel export for accounts",
      "Customer loyalty points",
    ],
    cta: "Get Gold",
  },
  {
    name: "Diamond",
    price: "3,999",
    period: "Yearly",
    perDay: "₹11",
    saving: "₹789",
    savingLabel: "Save ₹789 vs monthly",
    highlight: "₹11/day — 17% cheaper than Silver",
    forWho: "Multi-outlet restaurants & franchise chains",
    pop: false,
    tag: null,
    feats: [
      "Everything in Gold",
      "Kitchen Display System",
      "Advanced analytics dashboard",
      "Multi-outlet management",
      "Dedicated onboarding session",
      "Annual business review",
    ],
    cta: "Get Diamond",
  },
];

// ─── BUSINESS TYPES ───────────────────────────────────────────────────
export const BIZ = [
  { icon: "☕",  label: "Cafe" },
  { icon: "🍽️", label: "Fine Dine" },
  { icon: "🍺",  label: "Pubs & Bar" },
  { icon: "🥐",  label: "Bakery" },
  { icon: "🏪",  label: "Franchise" },
  { icon: "🥤",  label: "Juice Shop" },
  { icon: "🚗",  label: "Drive Thru" },
  { icon: "🍻",  label: "Brewery" },
  { icon: "🌮",  label: "Food Court" },
  { icon: "☁️",  label: "Cloud Kitchen" },
];

// ─── FAQS ─────────────────────────────────────────────────────────────
export const FAQS = [
  { q: "What is Ooon Restaurant POS & Billing Software?",  a: "Ooon is an all-in-one cloud-based restaurant management system covering POS billing, KOT, inventory, kitchen display, GST compliance, and detailed reports — all from one app." },
  { q: "Who can use Ooon?",                                 a: "Any food business — restaurants, cafés, cloud kitchens, bakeries, bars, juice shops, drive-throughs, food courts, and franchise chains." },
  { q: "Is Ooon cloud-based?",                             a: "Yes. Ooon is fully cloud-based, so your data is always synced, backed up, and accessible from any device with an internet connection." },
  { q: "Can I customise menus and pricing?",               a: "Absolutely. Add, edit, and update menu items, categories, pricing, and offers instantly from the admin panel." },
  { q: "Does Ooon support GST billing?",                   a: "Yes — Ooon automatically handles CGST, SGST, IGST, and UTGST for both intra-state and inter-state transactions." },
  { q: "Can I export reports to Excel?",                   a: "Yes. Any report or dataset can be exported to Excel for auditing, review, or sharing with your accountant." },
  { q: "Is there a loyalty programme feature?",            a: "Yes. You can set up a redeemable points system to reward repeat customers and track redemptions within the app." },
  { q: "Do I need technical knowledge to set up Ooon?",    a: "No. Ooon is designed for zero technical setup — install on any Android device and you can start billing within minutes." },
];

// ─── TESTIMONIALS ─────────────────────────────────────────────────────
export const TESTIMONIALS = [
  { text: "Ooon's KOT system completely eliminated kitchen miscommunication. Orders are faster and wastage is down noticeably.", name: "Ramesh K.",  role: "Owner, Spice Garden Restaurant", init: "R" },
  { text: "The GST billing and Excel export saves us hours every month. Our accountant loves the reports.",                     name: "Priya M.",   role: "Manager, Bloom Café",           init: "P" },
  { text: "Loyalty points brought back so many regulars. The cloud sync means I can check my sales from anywhere, even home.", name: "Arun S.",    role: "Owner, The Grill House",        init: "A" },
];

// ─── SOCIAL LINKS ─────────────────────────────────────────────────────
export const SOCIALS = [
  { label: "fb", url: "https://www.facebook.com/buyp" },
  { label: "𝕏",  url: "https://twitter.com/BuypTech" },
  { label: "ig", url: "https://www.instagram.com/buyptechnologies/" },
  { label: "yt", url: "https://www.youtube.com/@buyp" },
  { label: "in", url: "https://www.linkedin.com/company/buyp" },
];

// ─── LINKS ────────────────────────────────────────────────────────────
export const APP_URL       = "https://ooon.buypapps.com/";
export const PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=com.Buyp.Ooon_App";
export const WHATSAPP_URL  = "https://wa.me/919047281212?text=Hi%2C%20I%20want%20to%20know%20more%20about%20Ooon%20POS";

// ─── SEO META PER PAGE ────────────────────────────────────────────────
export const PAGE_SEO = {
  home: {
    title: "Ooon | #1 Restaurant POS & Billing Software India | Free Trial",
    description: "Ooon is India's smart restaurant POS & billing software. KOT, GST billing, inventory tracking, kitchen display, loyalty points & 20+ features. Try free for 15 days.",
    keywords: "restaurant POS software India, restaurant billing software, KOT system, GST billing restaurant, free restaurant POS, cafe billing app, Petpooja alternative, restaurant management software",
  },
  about: {
    title: "About Ooon | Cloud Restaurant POS by Buyp | India",
    description: "Learn about Ooon — a cloud-based restaurant POS & billing software built by Buyp with 11+ years of experience. Serving 500+ restaurants across India.",
    keywords: "about Ooon POS, Buyp restaurant software, cloud restaurant management India, restaurant billing app India",
  },
  features: {
    title: "Ooon Features & Pricing | Restaurant POS Software | KOT, GST, Inventory",
    description: "Explore all 20+ features of Ooon POS — KOT, kitchen display, GST billing, inventory, reports, loyalty, and more. Plans from ₹0 to ₹3,999/year.",
    keywords: "restaurant POS features, KOT kitchen order ticket, GST restaurant billing, restaurant inventory software, restaurant loyalty program, POS pricing India",
  },
  contact: {
    title: "Contact Ooon | Restaurant POS Support | 1800 890 0803",
    description: "Get in touch with the Ooon team for demos, support, or billing queries. Call toll-free 1800 890 0803 or WhatsApp us.",
    keywords: "Ooon contact, restaurant POS support India, Ooon demo, restaurant billing software help",
  },
};
